<script lang="ts" setup>
import { onUnmounted } from 'vue';
import InternalChatUserList from './InternalChatUserList.vue';
import InternalChatMessageArea from './InternalChatMessageArea.vue';
import { useInternalChatStore } from '@src/stores/internalChat';

const store = useInternalChatStore();
onUnmounted(() => store.clearSelection());
</script>

<template>
    <div class="h-full flex overflow-hidden relative">
        <div
            :class="store.selectedUserId ? 'xs:hidden md:flex md:flex-col' : 'flex flex-col'"
            class="xs:w-full md:w-78.5 md:flex-shrink-0 border-r border-gray-100 dark:border-gray-700 overflow-visible"
        >
            <InternalChatUserList/>
        </div>
        <div
            :class="store.selectedUserId
                ? 'flex flex-col xs:absolute xs:inset-0 xs:z-10 md:static md:flex-1'
                : 'xs:hidden md:flex md:flex-col md:flex-1'"
            class="overflow-hidden"
        >
            <InternalChatMessageArea/>
        </div>
    </div>
</template>
